import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { Toaster } from './components/ui/sonner';
import ProtectedRoute from './components/ProtectedRoute';
import Launcher from './pages/Landing';
import Login from './pages/Login';
import People from './pages/People';
import Assets from './pages/Assets';
import AssetScan from './pages/AssetScan';
import MyAssets from './pages/MyAssets';
import ScanQR from './pages/ScanQR';
import FinanceBooks from './pages/FinanceBooks';
import ComingSoon from './pages/ComingSoon';
import Admin from './pages/Admin';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/scan/asset/:code" element={<AssetScan />} />
          <Route path="/scan-qr" element={<ScanQR />} />
          <Route path="/" element={<Launcher />} />
          <Route
            path="/people"
            element={
              <ProtectedRoute>
                <People />
              </ProtectedRoute>
            }
          />
          <Route
            path="/assets"
            element={
              <ProtectedRoute>
                <Assets />
              </ProtectedRoute>
            }
          />
          <Route
            path="/my-assets"
            element={
              <ProtectedRoute>
                <MyAssets />
              </ProtectedRoute>
            }
          />
          <Route
            path="/execution"
            element={
              <ProtectedRoute>
                <ComingSoon wordmark="EXECUTION" subtitle="Project Execution" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/finance"
            element={
              <ProtectedRoute>
                <FinanceBooks />
              </ProtectedRoute>
            }
          />
          <Route
            path="/finance-books"
            element={<Navigate to="/finance" replace />}
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <Admin />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
